import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'UPDATE_CONTRACT';

export async function updateContract(
    userToken: string,
    updatedContract: Record<string, unknown>,
    contractId: number
) {
    try {
        const response = await axios({
            method: 'patch',
            url: `${URL}/contracts/${contractId}/`,
            data: updatedContract,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de modification du contrat.',
            error: error
        });
    }
}
